import { AVAnalyticsFormNames, AVRProducts, AVAnalyticsFlowNames } from './enums';

// ----- Each event maps to a flow
// start pages are the pages where the form starts and could trigger form open and form start events
// submit pages are the pages where the form is submitted and could trigger form complete events
// complete pages are the pages where the form is completed on page view and could trigger form complete events
// the flowName is a parameter that is sent to ASC analytics to identify the flow, the values are defined by ASC,
// see https://docs.google.com/spreadsheets/d/1AXdwZ9eAxhhGvhtij5MQlC-3CSXxR8vQ0ri9X3ACD4U/edit?pli=1&gid=1925342755#gid=1925342755
export const AVAnalyticsEvents = [
  {
    formName: AVAnalyticsFormNames.ECOMMERCE_PERSONALIZED_PAYMENTS,
    flowName: AVAnalyticsFlowNames.CREDIT,
    product: AVRProducts.ECOMV2,
    startPages: [
      'e-commerce-v2/personalized-payment/down-payment-form',
      'e-commerce-v2/personalized-payment/trade-in-form',
    ],
    submitPages: [
      'e-commerce-v2/personalized-payment/confirm-credit-form',
      'e-commerce-v2/personalized-payment/verify-credit-form',
    ],
  },
  {
    formName: AVAnalyticsFormNames.ECOMMERCE_PERSONALIZED_PAYMENTS_CONTACT_FORM,
    flowName: AVAnalyticsFlowNames.CREDIT,
    product: AVRProducts.ECOMV2,
    isCOAGOnlyEvent: true,
    startPages: ['e-commerce-v2/personalized-payment/contact-info-form'],
    submitPages: ['e-commerce-v2/personalized-payment/contact-info-form'],
  },
  {
    formName: AVAnalyticsFormNames.ECOMMERCE_TRADE,
    flowName: AVAnalyticsFlowNames.TRADE,
    product: AVRProducts.ECOMV2,
    startPages: ['trade-in/vehicle-autocomplete', 'trade-in/carfax-basic-form'],
    completePages: ['trade-in/trade-in-results'],
  },
  {
    formName: AVAnalyticsFormNames.ECOMMERCE_CREDIT,
    flowName: AVAnalyticsFlowNames.CREDIT,
    product: AVRProducts.ECOMV2,
    startPages: ['credit/name-form'],
    submitPages: ['/credit/confirm-credit-form', '/credit/verify-credit-form'],
  },
  {
    formName: AVAnalyticsFormNames.ECOMMERCE_FINANCE,
    flowName: AVAnalyticsFlowNames.FINANCE,
    product: AVRProducts.ECOMV2,
    startPages: ['finance/employment-details-form'],
    completePages: ['finance/finance-thank-you'],
  },
  {
    formName: AVAnalyticsFormNames.ECOMMERCE_MAKE_AN_OFFER_SUB_FLOW,
    flowName: AVAnalyticsFlowNames.ECOMMERCE,
    product: AVRProducts.ECOMV2,
    startPages: ['offer/offer-summary-form'],
    completePages: ['offer/offer-thank-you'],
  },
  {
    formName: AVAnalyticsFormNames.TRADE,
    flowName: AVAnalyticsFlowNames.TRADE,
    product: AVRProducts.TRADE,
    startPages: [
      'tradein/year',
      'tradein/vehicle-autocomplete',
      'personal-info-form',
      'tradein/select-trade-vehicle-type',
      'tradein/trade-vehicle-details',
      'tradein/carfax-basic-form',
      'carfax-details-form',
    ],
    completePages: ['tradein/report'],
  },
  {
    formName: AVAnalyticsFormNames.CREDIT,
    flowName: AVAnalyticsFlowNames.CREDIT,
    product: AVRProducts.CREDIT,
    startPages: ['credit/select-vehicle-type', 'credit/disclaimer', 'credit-form/creditform1'],
    submitPages: ['credit-form/form-review'],
    completePages: ['credit-form/credit-results', 'credit/credit-results'],
  },
  {
    formName: AVAnalyticsFormNames.INSURANCE,
    flowName: AVAnalyticsFlowNames.COMPARE,
    product: AVRProducts.INSURANCE,
    startPages: ['insurance-application/personalform', 'insurance/disclaimer'],
    completePages: ['insurance-application/quote'],
  },
  {
    formName: AVAnalyticsFormNames.TEST_DRIVE,
    flowName: AVAnalyticsFlowNames.TEST_DRIVE,
    product: AVRProducts.TEST_DRIVE,
    startPages: ['test-drive/choose-date', 'test-drive/choose-location', 'test-drive/test-drive-from-home'],
    completePages: ['test-drive/request-submitted'],
  },
  {
    formName: AVAnalyticsFormNames.FINANCE,
    flowName: AVAnalyticsFlowNames.FINANCE,
    product: AVRProducts.CREDIT,
    startPages: ['finance-application/employer-form'],
    completePages: ['finance-application/thank-you'],
  },
];

export default AVAnalyticsEvents;
